module.exports = __webpack_public_path__ + "assets/img/introduction-en.a83663ae.png";